function getString(key) {
    if (!("ENVIRONMENT" in window) || window.ENVIRONMENT === null) {
        throw new Error("window.ENVIRONMENT not defined");
    }
    if (typeof window.ENVIRONMENT !== "object") {
        throw new Error("window.ENVIRONMENT is the wrong type");
    }
    const unsafeEnvironment = window.ENVIRONMENT;
    if (!(key in unsafeEnvironment)) {
        throw new Error(`Environment value ${key} is not defined`);
    }
    const value = unsafeEnvironment[key];
    if (value === undefined || value === null) {
        throw new Error(`Environment value ${key} is not defined`);
    }
    if (typeof value !== "string") {
        throw new Error(`Environment value ${key} is the wrong type: ${typeof value}`);
    }
    return value;
}
function getBoolean(key) {
    if (!("ENVIRONMENT" in window) || window.ENVIRONMENT === null) {
        throw new Error("window.ENVIRONMENT not defined");
    }
    if (typeof window.ENVIRONMENT !== "object") {
        throw new Error("window.ENVIRONMENT is the wrong type");
    }
    const unsafeEnvironment = window.ENVIRONMENT;
    if (!(key in unsafeEnvironment)) {
        throw new Error(`Environment value ${key} is not defined`);
    }
    const value = unsafeEnvironment[key];
    if (value === undefined || value === null) {
        throw new Error(`Environment value ${key} is not defined`);
    }
    if (typeof value === "string") {
        return value === "true";
    }
    if (typeof value !== "boolean") {
        throw new Error(`Environment value ${key} is the wrong type: ${typeof value}`);
    }
    return value;
}
export class Environment {
    constructor() {
        this.API_BASE_URL = getString("API_BASE_URL");
        this.PUBLIC_CALLBACK_BASE_URL = getString("PUBLIC_CALLBACK_BASE_URL");
        this.WEBAPP_BASE_URL = getString("WEBAPP_BASE_URL");
        this.WEB_ROOT_DOMAIN = getString("WEB_ROOT_DOMAIN");
        this.WEBSITE_BASE_URL = getString("WEBSITE_BASE_URL");
        this.DOCS_BASE_URL = getString("DOCS_BASE_URL");
        this.HEALTHEX_PUBLIC_API_VERSION = getString("HEALTHEX_PUBLIC_API_VERSION");
        this.ENABLE_INSTRUMENTATION = getString("ENABLE_INSTRUMENTATION");
        this.NEW_RELIC_BROWSER_LICENSE_KEY = getString("NEW_RELIC_BROWSER_LICENSE_KEY");
        this.NEW_RELIC_BROWSER_APP_ID = getString("NEW_RELIC_BROWSER_APP_ID");
        this.NEW_RELIC_SERVICE_NAME = getString("NEW_RELIC_SERVICE_NAME");
        this.FASTEN_PRODUCTION_PUBLIC_ID = getString("FASTEN_PRODUCTION_PUBLIC_ID");
        this.FASTEN_NONPRODUCTION_PUBLIC_ID = getString("FASTEN_NONPRODUCTION_PUBLIC_ID");
        this.FASTEN_API_BASE_URL = getString("FASTEN_API_BASE_URL");
        this.FASTEN_LOGO_BASE_URL = getString("FASTEN_LOGO_BASE_URL");
        this.ADDITIONAL_CONSENT_SCOPES_ENABLED = getString("ADDITIONAL_CONSENT_SCOPES_ENABLED") === "true";
        this.HIDE_STUDY_INFORMATION_STEP_ORG_IDS = getString("HIDE_STUDY_INFORMATION_STEP_ORG_IDS");
        this.TOKEN_EXPIRATION_CUTOFF_TIMESTAMP_SECONDS = getString("TOKEN_EXPIRATION_CUTOFF_TIMESTAMP_SECONDS");
        this.CSS_DEBUG = getBoolean("CSS_DEBUG");
    }
}
